module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox float-e-margins sec-skeleton"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content",
    style: ({
      minHeight: (_vm.height + "px")
    })
  }, [_c('span', {
    staticClass: "sec-skeleton__bar sec-skeleton__bar--line"
  }), _vm._v(" "), _c('div', {
    staticClass: "sec-skeleton__grid"
  }, _vm._l((_vm.blocks), function(n) {
    return _c('span', {
      key: n,
      staticClass: "sec-skeleton__block"
    })
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('span', {
    staticClass: "sec-skeleton__bar sec-skeleton__bar--title"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ee41f2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/segmentation/common/SectionSkeleton.vue
// module id = 3140
// module chunks = 3